import React from "react";
import { connect } from "react-redux";
import { Container, Row } from "reactstrap";
import CardRequestsTable from "./components/CardStatementTable";
import PageHeader from "../../../shared/components/PageHeader";

const CardStatement = () => (
  <Container>
    <PageHeader
      header="Get Card Statement"
      subheader="Generate a user's card transaction statement"
    />
    <Row>
      <CardRequestsTable />
    </Row>
  </Container>
);

export default connect(state => ({
  requests: state.getAllCardRequests
}))(CardStatement);
